module.exports = __webpack_public_path__ + "img/domit.900affd8.png";